export const MIN_DAILY_RECORDINGS = 1;
export const MIN_DAILY_SECONDS = 10;
export const MIN_DAILY_SPELLINGS = 1;
